<template>
  <body class="forBrands-body" id="forBrands">
    <div class="text-wrapper">
      <TextLabel labelColor="white" labelText="Partnership Program" />
      <div class="title">For Brands</div>
      <div class="text">
        At Wecobi, we are committed to empowering brands to thrive in a dynamic
        retail landscape by turning unsold inventory into opportunities. Our
        Partner Program is designed for forward-thinking brands and businesses
        that want to align profitability with sustainability. By joining our
        program, you’ll unlock access to Wecobi’s innovative platform and
        benefit from a wide array of tools, resources, and support that enable
        you to optimize your inventory management while minimizing waste.
      </div>
    </div>
    <div class="image-wrapper"></div>
  </body>
</template>

<script>
import TextLabel from "@/components/Sustainability/Content/ReusableComponents/TextLabel.vue";

export default {
  name: "ForBrands",
  components: {
    TextLabel,
  },
};
</script>

<style scoped>
.forBrands-body {
  width: 100%;
  height: 650px;
  border-radius: 20px;
  display: flex;
  overflow: hidden;
}
.text-wrapper {
  width: 50%;
  height: 100%;
  background: linear-gradient(to left, #000000 0%, #232323 100%);
  padding: 0px 70px 0px 90px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.image-wrapper {
  width: 50%;
  height: 100%;
  background-image: url("../../../assets/PartnersProgram/PartnersProgram.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.title {
  font-size: 45px;
  font-weight: 600;
  line-height: 1.2;
  color: #ffffff;
}
.text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #ffffff;
}

@media (max-width: 1280px) {
  .title {
    font-size: 40px;
  }
  .text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .text-wrapper {
    padding: 0px 70px 0px 80px;
    gap: 20px;
  }
  .title {
    font-size: 35px;
  }
}
@media (max-width: 850px) {
  .forBrands-body {
    flex-direction: column-reverse;
    height: 726px;
  }
  .text-wrapper {
    padding: 0px 60px;
    gap: 20px;
  }
  .text-wrapper,
  .image-wrapper {
    width: 100%;
    height: 50%;
  }
  .hide {
    display: none;
  }
}
@media (max-width: 588px) {
  .forBrands-body {
    height: 599px;
  }
  .text-wrapper {
    padding: 0px 50px;
    gap: 20px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 431px) {
  .forBrands-body {
    height: 700px;
  }
  .image-wrapper {
    height: 291px;
  }
  .text-wrapper {
    padding: 0px 40px;
    gap: 20px;
    height: 409px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
</style>
